import { setOpenModal, setContent, setAiContext } from 'store/ai-modal';

const AI_ICON = `<svg class="custom-ai-assistan-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px"><defs><linearGradient id="joditAiIconGradient" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" class="jodit-ai-gradient-stop-start"/><stop offset="50%" class="jodit-ai-gradient-stop-mid"/><stop offset="100%" class="jodit-ai-gradient-stop-end"/></linearGradient></defs><path fill="url(#joditAiIconGradient)" d="M12,0C11.743,6.518,6.518,11.743,0,12c6.518,0.257,11.743,5.482,12,12c0.257-6.518,5.482-11.743,12-12	C17.482,11.743,12.257,6.518,12,0z M12,17.163C10.743,15.039,8.961,13.257,6.837,12C8.961,10.743,10.743,8.961,12,6.837	c1.257,2.124,3.039,3.906,5.163,5.163C15.039,13.257,13.257,15.039,12,17.163z"/></svg>`;

export const openAiAssistant = (editorInstance, dispatch) => {
  if (!editorInstance || !dispatch) {
    return;
  }
  const editorDoc = editorInstance.editorDocument;
  let selectedHtml = '';

  if (editorDoc) {
    const selection = editorDoc.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const container = document.createElement('div');
      container.appendChild(range.cloneContents());
      selectedHtml = container.innerHTML.trim();
    }
  }
  const fullHtml = editorInstance.value || '';
  dispatch(setOpenModal(true));
  dispatch(setContent(selectedHtml !== '' ? selectedHtml : fullHtml));
  dispatch(
    setAiContext({
      full: fullHtml,
      selectedHtml: selectedHtml || null,
    }),
  );
};

export const getAiButton = (dispatch) => ({
  name: 'aiButton',
  tooltip: 'Ai Review',
  icon: AI_ICON,
  exec: (editorInstance) => openAiAssistant(editorInstance, dispatch),
});
